import api from "./api";

const getCourses = async (page, search) => await api.get('course/search', {
    params: {
        offset: page * global.PAGE_SIZE, limit: global.PAGE_SIZE, search
    }
})
const getBookmarkCourses = async (id, page) => await api.get('course/bookmark', {
    params: {
        offset: page * global.PAGE_SIZE, limit: global.PAGE_SIZE, id
    }
})
const getBookmarkLessons= async (id, page) => await api.get('course/lesson/bookmark', {
    params: {
        offset: page * global.PAGE_SIZE, limit: global.PAGE_SIZE, id
    }
})
const getBoughtCourses = async ( page) => await api.get('course/bought', {
    params: {
        offset: page * global.PAGE_SIZE, limit: global.PAGE_SIZE
    }
})
const getCourse = async (courseId) => await api.get(`course/${courseId}`)
const getLesson = async (courseId,lessonId) => await api.get(`course/${courseId}/lesson/${lessonId}`)

const paymentRequest = async (courseId, offCode) => await api.get(`course/${courseId}/paymentRequest`, {
    params: {
        offCode, isBazaar: false,isSite:true
    }
})
const getCourseComments = async (courseId, page) => await api.get(`course/${courseId}/comments`, {
    params: {
        offset: page * global.PAGE_SIZE, limit: global.PAGE_SIZE
    }
})
const addCourseComment = async (courseId, text) => await api.post(`course/${courseId}/comments`, {text})

const getCourseQuestions = async (courseId, page) => await api.get(`course/${courseId}/questions`, {
    params: {
        offset: page * global.PAGE_SIZE, limit: global.PAGE_SIZE
    }
})
const addCourseQuestion = async (courseId, text) => await api.post(`course/${courseId}/questions`, {text})

export default {
    getCourses,
    getCourse,getLesson,
    getCourseComments,
    addCourseComment,
    getCourseQuestions,
    addCourseQuestion,
    getBookmarkCourses,getBookmarkLessons,
    paymentRequest,getBoughtCourses
}
